import { render } from "./BigBallBall.vue?vue&type=template&id=3f15dfb0&scoped=true"
import script from "./BigBallBall.vue?vue&type=script&lang=js"
export * from "./BigBallBall.vue?vue&type=script&lang=js"

import "./BigBallBall.vue?vue&type=style&index=0&id=3f15dfb0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f15dfb0"]])

export default __exports__